import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} StudentUpdateData
 * @property {string} [name]           // Max 100 chars
 * @property {string} [parent_email]   // Optional
 * @property {string} [username]       // Must be unique if provided
 * @property {string} [password]       // Min 6 chars
 * @property {number} [age]            // Integer 1–100
 * @property {number} [assigned_to]    // Valid teacher ID (nullable)
 *
 */

export const useUpdateStudent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * Update Student by ID
   * @param {object} params
   * @param {number|string} params.studentId
   * @param {StudentUpdateData} params.updatedData
   * @param {() => void} [params.onSuccess] - Optional callback on successful update
   */
  const updateStudent = async ({ studentId, updatedData, onSuccess }) => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.put(
        `${TENANT_DOMAIN}/student/update/${studentId}`,
        updatedData,
      );

      // Call onSuccess callback if provided
      if (onSuccess) {
        onSuccess();
      }

      return response.data;
    } catch (err) {
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        const apiErrors = err?.response?.data?.errors;
        const firstError = apiErrors && Object.values(apiErrors)?.[0]?.[0];

        setError(
          firstError || err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN,
        );
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { updateStudent, loading, error };
};

